import styled from 'styled-components';

/* "More" trigger glyph wrapper — colour is inherited from the trigger button
   (rest = side-menu item tone, open/hover = the nav accent), so the dots track
   the button's state. The chrome's `.icon svg` rules size the inner svg. */
export const Glyph = styled.span`
  display: block;
  color: inherit;

  svg {
    display: block;
  }
`;
